// The branch vocabulary printed on documents and offered in the branch
// pickers. Shared config rather than page-local: three pages (quote generator,
// manual tax invoice, temporary delivery note) offer the same list, and the
// lnwshop message importers map a numeric branch id onto it BY INDEX.
//
// Do not change the order — index 0 must stay สำนักงานใหญ่ and index N must
// stay สาขาที่ 0000N, or an imported order silently lands on a different
// branch than the customer stated.
export const branchList: string[] = [
    'สำนักงานใหญ่',
    'สาขาที่ 00001',
    'สาขาที่ 00002',
    'สาขาที่ 00003',
    'สาขาที่ 00004',
    'สาขาที่ 00005',
    'สาขาที่ 00006',
    'สาขาที่ 00007',
    'สาขาที่ 00008',
    'สาขาที่ 00009',
    'สาขาที่ 00010',
];
